import React from 'react';
import styled from 'styled-components';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { CalculatorResultsPageProps } from '../../calculator/models';
import { calculateCompetitionMonthlyPrices, calculateMonthlySavings } from '../../calculator/utils';
import { ctaProps } from 'packages/smart-home-support/constants';
import BREAK_POINTS from '../../../styling/media-queries';
import getPartnerAsset, { DynamicAssetsKeys } from 'packages/smart-home-support/assets';
import { LinkProps } from '@soluto-home-web/platform-common-ui';
import { ProtectItContainerProps } from 'packages/smart-home-support/assets/components/ProtectItContainer';
import { useDevicesFromQueryString } from 'packages/smart-home-support/hooks';
import { PartnerContent } from 'packages/smart-home-support/partner';

const Subheading = styled.div`
  font-style: normal;
  text-align: center;
  color: ${(props) => props.theme.colors.protectItFontColor || '#fefefe'};
  font-size: 18px;
  line-height: 1.1;
  @media ${BREAK_POINTS.mobileBig} {
    font-size: 22px;
  }
  @media ${BREAK_POINTS.tablet} {
    font-size: 28px;
    line-height: 32px;
  }
`;

const TCHFaqLinkContainer = styled.div`
  margin-top: 20px;
  background: rgba(255, 255, 255, 0.7);
  padding: 10px;
  @media ${BREAK_POINTS.mobileBig} {
    background: none;
    padding: 0;
  }
`;

const TCHFaqLink = styled(Link)`
  font-size: 18px;
  color: #000;
  line-height: 1.2;
`;

const protectItImage: string = getPartnerAsset(DynamicAssetsKeys.protectItImage);
const ProtectItContainer: React.FC<ProtectItContainerProps> = getPartnerAsset(DynamicAssetsKeys.homeProtectItContainer);
const ProtectItSubtitle: React.FC<{ maxPrice: number }> = getPartnerAsset(
  DynamicAssetsKeys.homeProtectItSubtitleComponent
);
const protectItSubtitle2: string = getPartnerAsset(DynamicAssetsKeys.homeProtectItSubtitle2);
const ProtectItCta: React.FC<LinkProps> = getPartnerAsset(DynamicAssetsKeys.homeProtectItCtaComponent);
const ProtectItTitle: React.FC<any> = getPartnerAsset(DynamicAssetsKeys.homeProtectItTitleComponent);
const ProtectItTitleText: JSX.Element = getPartnerAsset(DynamicAssetsKeys.homeProtectItTitle);
const ProtectItTextContainer: React.FC<any> = getPartnerAsset(DynamicAssetsKeys.homeProtectItTextContainer);

const ProtectIt: React.FunctionComponent<CalculatorResultsPageProps & RouteComponentProps> = (props) => {
  const { competitors, devices, location } = props;

  const selectedDevices = useDevicesFromQueryString(location, devices);

  const competitionMonthlyPrices = calculateCompetitionMonthlyPrices(competitors, devices, selectedDevices);

  const maxPrice: number = calculateMonthlySavings(competitionMonthlyPrices) + 20;

  return (
    <ProtectItContainer imageUrl={protectItImage}>
      <ProtectItTextContainer>
        <ProtectItTitle>{ProtectItTitleText}</ProtectItTitle>
        <Subheading>
          <ProtectItSubtitle maxPrice={maxPrice} />
        </Subheading>
        {protectItSubtitle2 && <br />}
        <Subheading>
          <strong>{protectItSubtitle2}</strong>
        </Subheading>
        <PartnerContent Verizon="">
          <ProtectItCta {...ctaProps} />
        </PartnerContent>
        <PartnerContent
          TechCoachHome={
            <TCHFaqLinkContainer>
              <TCHFaqLink to="/faq">Click here to see changes coming in July</TCHFaqLink>
            </TCHFaqLinkContainer>
          }
        />
      </ProtectItTextContainer>
    </ProtectItContainer>
  );
};

export default ProtectIt;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/homepage/components/ProtectIt.tsx